import request from './http'



export default {

    //首页 业务板块首页、图片
    getBusiness(params) {
        return request({
            url: '/materials/a/cms/api/getBusiness',
            method: 'get',
            params
        })
    },

    //业务板块、图片
    getRotationByType(params) {
        return request({
            url: '/materials/a/cms/api/getRotation',
            method: 'get',
            params
        })
    },
    //业务板块内容
    getCategoryDetail(params) {
        return request({
            url: '/materials/a/cms/api/getCategoryDetailById',
            method: 'get',
            params
        })
    },
    //信息公开列表
    getCategoryById(params) {
        return request({
            url: '/materials/a/cms/api/getCategoryById',
            method: 'get',
            params
        })
    },
    //信息公开获取文章详情
    getArticleData(params) {
        return request({
            url: '/materials/a/cms/api/getArticleData',
            method: 'get',
            params
        })
    },

    // materials/a/cms/api/getBrief?catId=f1c0af20344a413fb35498338645dccb
    // 中欧班列等其他几个板块 公用接口
    zhongoubanlieData(params) {
        return request({
            url: '/materials/a/cms/api/getBrief',
            method: 'get',
            params
        })
    },


    getCompany(params) {
        return request({
            url: '/materials/a/cms/api/getCompany',
            method: 'get',
            params
        })
    },

}